export enum MessageRole {
    USER = 'user',
    MODEL = 'model'
}

export interface ChatMessage {
    id: string;
    role: MessageRole;
    text: string;
    timestamp: Date;
    isToolCall?: boolean;
}

export interface NodeDevice {
    id: string | number;
    name: string;     // Nombre
    ip: string;       // IP
    channel: number;  // CANAL
    port: number;     // PUERTO
    brand: string;    // MARCA
    type: string;     // TIPO
    status: string;   // ESTADO
}
